interface Supplier {
  id: string;
  organization: string;
  representative: string;
  address: string;
  email: string;
  phone?: string;
  mobile?: string;
  products: string;
  slug: string;
  subdomain: string;
  verified: boolean;
  yearEstablished?: number;
  rating: number;
  totalProducts: number;
  description: string;
  specialties: string[];
  location: string;
  city: string;
  avatar?: string;
  status?: string;
  created_at?: string;
  reviews?: number;
}

export const suppliers: Supplier[] = [
  {
    id: '1',
    organization: 'Bengal Textiles Ltd.',
    representative: 'Md. Rahman',
    address: '123 Textile Street, Dhaka 1000',
    email: 'contact@bengaltextiles.com',
    phone: '+880-2-9876543',
    mobile: '+880-1711-123456',
    products: 'Cotton T-Shirts, Polo Shirts, Casual Wear, Corporate Uniforms',
    slug: 'bengal-textiles',
    subdomain: 'bengaltextiles.madeinbd.com',
    verified: true,
    yearEstablished: 1995,
    rating: 4.9,
    totalProducts: 156,
    description: 'Leading manufacturer of premium cotton garments with 25+ years of export experience.',
    specialties: ['Cotton T-Shirts', 'Polo Shirts', 'Casual Wear', 'Corporate Uniforms'],
    location: 'Dhaka, Bangladesh',
    city: 'Dhaka',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-01-15T00:00:00Z',
    reviews: 245
  },
  {
    id: '2',
    organization: 'Eco Jute Co.',
    representative: 'Ms. Fatima',
    address: '456 Jute Mill Road, Khulna 9000',
    email: 'info@ecojute.bd',
    phone: '+880-41-123456',
    mobile: '+880-1812-345678',
    products: 'Jute Bags, Handicrafts, Home Decor, Eco-friendly Products',
    slug: 'eco-jute-co',
    subdomain: 'ecojute.madeinbd.com',
    verified: true,
    yearEstablished: 2005,
    rating: 4.7,
    totalProducts: 89,
    description: 'Sustainable jute products manufacturer committed to environmental conservation.',
    specialties: ['Jute Bags', 'Handicrafts', 'Home Decor', 'Eco Products'],
    location: 'Khulna, Bangladesh',
    city: 'Khulna',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-02-20T00:00:00Z',
    reviews: 189
  },
  {
    id: '3',
    organization: 'Heritage Weavers',
    representative: 'Mr. Karim',
    address: '789 Heritage Lane, Dhaka 1205',
    email: 'heritage@weavers.com',
    phone: '+880-2-5551234',
    mobile: '+880-1555-987654',
    products: 'Traditional Sarees, Handloom Fabrics, Cultural Textiles',
    slug: 'heritage-weavers',
    subdomain: 'heritage.madeinbd.com',
    verified: true,
    yearEstablished: 1980,
    rating: 4.8,
    totalProducts: 67,
    description: 'Preserving traditional weaving techniques while creating contemporary designs.',
    specialties: ['Jamdani Sarees', 'Handloom Fabrics', 'Traditional Textiles'],
    location: 'Dhaka, Bangladesh',
    city: 'Dhaka',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-03-10T00:00:00Z',
    reviews: 156
  },
  {
    id: '4',
    organization: 'Dhaka Leather Works',
    representative: 'Mr. Ahmed',
    address: '321 Leather Street, Dhaka 1100',
    email: 'info@dhakaleather.com',
    phone: '+880-2-7778888',
    mobile: '+880-1777-456789',
    products: 'Leather Bags, Wallets, Belts, Shoes, Accessories',
    slug: 'dhaka-leather-works',
    subdomain: 'dhakaleather.madeinbd.com',
    verified: true,
    yearEstablished: 1992,
    rating: 4.6,
    totalProducts: 134,
    description: 'Premium leather goods manufacturer with international quality standards.',
    specialties: ['Leather Bags', 'Wallets', 'Belts', 'Shoes'],
    location: 'Dhaka, Bangladesh',
    city: 'Dhaka',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-04-05T00:00:00Z',
    reviews: 198
  },
  {
    id: '5',
    organization: 'Bengal Fisheries',
    representative: 'Captain Hasan',
    address: '654 Port Road, Chittagong 4000',
    email: 'export@bengalfisheries.com',
    phone: '+880-31-654321',
    mobile: '+880-1654-321987',
    products: 'Frozen Fish, Prawns, Seafood, Marine Products',
    slug: 'bengal-fisheries',
    subdomain: 'bengalfisheries.madeinbd.com',
    verified: true,
    yearEstablished: 1988,
    rating: 4.5,
    totalProducts: 78,
    description: 'Leading seafood exporter with state-of-the-art freezing facilities.',
    specialties: ['Frozen Hilsa', 'Prawns', 'Marine Fish', 'Seafood'],
    location: 'Chittagong, Bangladesh',
    city: 'Chittagong',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-05-12T00:00:00Z',
    reviews: 167
  },
  {
    id: '6',
    organization: 'Cotton Craft BD',
    representative: 'Ms. Nasreen',
    address: '987 Cotton Mill Area, Gazipur 1700',
    email: 'orders@cottoncraft.bd',
    phone: '+880-2-9998877',
    mobile: '+880-1999-876543',
    products: 'Cotton Fabrics, Home Textiles, Bed Sheets, Towels',
    slug: 'cotton-craft-bd',
    subdomain: 'cottoncraft.madeinbd.com',
    verified: true,
    yearEstablished: 2001,
    rating: 4.4,
    totalProducts: 112,
    description: 'Specialized in cotton home textiles with modern manufacturing facilities.',
    specialties: ['Cotton Fabrics', 'Bed Sheets', 'Towels', 'Home Textiles'],
    location: 'Gazipur, Bangladesh',
    city: 'Gazipur',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-06-18T00:00:00Z',
    reviews: 134
  },
  {
    id: '7',
    organization: 'Pharma Plus Ltd.',
    representative: 'Dr. Mahmud',
    address: '147 Pharma Complex, Dhaka 1230',
    email: 'export@pharmaplus.com',
    phone: '+880-2-4445555',
    mobile: '+880-1444-567890',
    products: 'Generic Medicines, Health Supplements, Medical Devices',
    slug: 'pharma-plus',
    subdomain: 'pharmaplus.madeinbd.com',
    verified: true,
    yearEstablished: 1998,
    rating: 4.7,
    totalProducts: 89,
    description: 'WHO-GMP certified pharmaceutical manufacturer with global reach.',
    specialties: ['Generic Medicines', 'Health Supplements', 'Medical Devices'],
    location: 'Dhaka, Bangladesh',
    city: 'Dhaka',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-07-22T00:00:00Z',
    reviews: 178
  },
  {
    id: '8',
    organization: 'Green Recyclers',
    representative: 'Mr. Alam',
    address: '258 Industrial Zone, Chittagong 4100',
    email: 'business@greenrecyclers.bd',
    phone: '+880-31-777888',
    mobile: '+880-1777-234567',
    products: 'Recycled Materials, Scrap Metal, Plastic Waste, Paper Products',
    slug: 'green-recyclers',
    subdomain: 'greenrecyclers.madeinbd.com',
    verified: true,
    yearEstablished: 2010,
    rating: 4.3,
    totalProducts: 45,
    description: 'Environmental solutions through recycling and waste management.',
    specialties: ['Scrap Metal', 'Plastic Recycling', 'Paper Products'],
    location: 'Chittagong, Bangladesh',
    city: 'Chittagong',
    avatar: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg',
    status: 'verified',
    created_at: '2023-08-15T00:00:00Z',
    reviews: 98
  }
];

const getSupplierBySlug = (slug: string): Supplier | undefined => {
  return suppliers.find(supplier => supplier.slug === slug);
};

export const getSuppliersByCity = (city: string): Supplier[] => {
  return suppliers.filter(supplier => supplier.city.toLowerCase() === city.toLowerCase());
};

export const getSuppliersByProduct = (productKeyword: string): Supplier[] => {
  return suppliers.filter(supplier => 
    supplier.products.toLowerCase().includes(productKeyword.toLowerCase()) ||
    supplier.specialties.some(specialty => 
      specialty.toLowerCase().includes(productKeyword.toLowerCase())
    )
  );
};